import { scroller } from "react-scroll";
import Business from "./Components/Business";
import Home from "./Components/Home";
import About from "./Components/About";
import Footer from "./Components/Footer";
function App() {
  return (
    <div className="App">
      <Home/>
      
    </div>
  );
}

export default App;
